import styled from 'styled-components';

const HiddenFileInput = styled.input.attrs({
  type: 'file',
  accept: 'image/jpeg,image/jpg,image/png,image/gif',
  multiple: true
})`
  display: none;
`;

export default HiddenFileInput;
